import React from 'react'

import CompetitiveIntelligenceHeader from 'components/CompetitiveIntelligence/Header'
import MarketFilters from 'components/CompetitiveIntelligence/MarketFilters'
import MarketGrid from 'components/CompetitiveIntelligence/MarketGrid'
import MarketTabs from 'components/CompetitiveIntelligence/MarketTabs'
import ResearchListSkeleton from 'components/CompetitiveIntelligence/ResearchListSkeleton'
import CompetitiveIntelligenceState from 'components/CompetitiveIntelligence/State'
import useController from './controller'
import { Page } from './styled'

export default function CompetitiveIntelligenceMarket() {
  const controller = useController()
  return (
    <Page>
      <CompetitiveIntelligenceHeader
        description={controller.t('competitive_intelligence_market_description')}
        eyebrow={controller.t('competitive_intelligence_title')}
        t={controller.t}
        title={controller.t('competitive_intelligence_nav_market')}
      />
      <MarketTabs {...controller} />
      {controller.status === 'loading' ? (
        <ResearchListSkeleton label={controller.t('competitive_intelligence_market_loading')} />
      ) : ['ready', 'empty'].includes(controller.status) ? (
        <>
          <MarketFilters {...controller} />
          {controller.status === 'ready' ? (
            <MarketGrid {...controller} />
          ) : (
            <CompetitiveIntelligenceState
              actionLabel={controller.t('competitive_intelligence_research_clear_filters')}
              description={controller.t('competitive_intelligence_market_empty_description')}
              onAction={controller.onReset}
              title={controller.t('competitive_intelligence_market_empty_title')}
            />
          )}
        </>
      ) : (
        <CompetitiveIntelligenceState
          actionLabel={controller.t('try_again')}
          description={controller.t(controller.status === 'denied' ? 'competitive_intelligence_denied_description' : 'competitive_intelligence_unavailable_description')}
          onAction={controller.status === 'denied' ? undefined : controller.retry}
          title={controller.t(controller.status === 'denied' ? 'competitive_intelligence_denied_title' : 'competitive_intelligence_unavailable_title')}
          urgent
        />
      )}
    </Page>
  )
}
